import { useEffect } from 'react';

export const useAttachScript = (url: string, isAsync: boolean, isDefer: boolean): void => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = url;
    script.async = isAsync;
    script.defer = isDefer;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, [url, isAsync]);
};
